import React from 'react';
import styles from '../assets/styles/ContactDetailLabelNav.module.css';

const ContactDetailLabelNav = ({ href, icon, text }) => {
  return (
    <a href={href} className={styles.label}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.text}>{text}</div>
    </a>
  );
};

export default ContactDetailLabelNav;